import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const documentForm = {
  title: "",
  committee: "",
  category: "",
  file: "",
  fileCheck: "",
};

//create slice
const name = "documents";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports
export const documentsActions = { ...slice.actions, ...extraActions };
export const documentsReducer = slice.reducer;

function createInitialState() {
  return {
    categories_List: {},
    documents_List: {},
    clearDocumentList: {},
    createDocumentRes: {},
    updateDocumentRes: {},
    documentForm: documentForm,
    createDocRes: {},
    updateDocRes: {},
    AlldocList: {}, //Admin
    deleteRes: {},
    statusChangeRes: {},
    loading: false,
    catloading: false,
  };
}

function createReducers() {
  return {
    clearDocumentList,
    updateDocumentForm,
    resetDocumentForm,
  };

  function updateDocumentForm(state, action) {
    state.documentForm = action.payload;
  }

  function resetDocumentForm(state) {
    state.documentForm = documentForm;
  }

  function clearDocumentList(state) {
    state.documents_List = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getCategoriesList: getCategoriesList(),
    getDocumentsByCategory: getDocumentsByCategory(),
    CreateDocument: CreateDocument(),
    UpdateDocument: UpdateDocument(),
    getAllDocuments: getAllDocuments(),
    DeleteDocments: DeleteDocments(),
    dcoumentStatusChange: dcoumentStatusChange(),
    getAllDocumentSearch: getAllDocumentSearch(),
    trackDownloads: trackDownloads(),
  };

  // delete documents DeleteDocments
  function dcoumentStatusChange() {
    return createAsyncThunk(
      `${name}/dcoumentStatusChange`,
      async (id) =>
        await fetchWrapper.patch(`${baseUrl}/document/toggle-status/${id}`)
    );
  }

  // delete documents DeleteDocments
  function DeleteDocments() {
    return createAsyncThunk(
      `${name}/DeleteDocments`,
      async (id) => await fetchWrapper.delete(`${baseUrl}/document/${id}`)
    );
  }

  /* get categories by Committee_ID */
  function getCategoriesList() {
    return createAsyncThunk(
      `${name}/getCategoriesList`,
      async (id, params) =>
        await fetchWrapper.get(`${baseUrl}/category/committee/${id}`)
    );
  }


  function CreateDocument() {
    return createAsyncThunk(`${name}/CreateDocument`, async ({ id, body }) => {
      return await fetchWrapper.post(
        `${baseUrl}/document?committee=${id}`,
        body // FormData here
      );
    });
  }

  function UpdateDocument() {
    return createAsyncThunk(`${name}/UpdateDocument`, async ({ id, body }) => {
      return await fetchWrapper.patch(
        `${baseUrl}/document/${id}`,
        body // FormData here
      );
    });
  }

  function getDocumentsByCategory() {
    return createAsyncThunk(
      `${name}/getDocumentsByCategory`,
      async ({ id, params }) =>
        await fetchWrapper.get(
          // `${baseUrl}/document/by-category/${id}?sort=-createdAt&limit=${limit}&page=${page}`
          // `${baseUrl}/document/by-category/${id}/date-filter?sort=-createdAt${params}`
          `${baseUrl}/document/by-category/${id}/date-filter?sort=title${params}`
        )
    );
  }

  //
  function getAllDocuments() {
    return createAsyncThunk(
      `${name}/getAllDocuments`,
      async (id) =>
        await fetchWrapper.get(`${baseUrl}/document?committee=${id}`)
    );
  }

  function getAllDocumentSearch() {
    return createAsyncThunk(
      `${name}/getAllDocumentSearch`,
      async ({ id, params }) =>
        await fetchWrapper.get(`${baseUrl}/document?committee=${id}${params}`)
    );
  }

  // Track download Documents
  function trackDownloads() {
    return createAsyncThunk(
      `${name}/trackDownloads`,
      async ({ id }) =>
        await fetchWrapper.post(`${baseUrl}/document/${id}/download`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(documentsActions.getCategoriesList.pending, (state) => {
      state.catloading = true;
      state.error = null;
    })
    .addCase(documentsActions.getCategoriesList.fulfilled, (state, action) => {
      state.catloading = false;
      state.categories_List = action.payload;
    })
    .addCase(documentsActions.getCategoriesList.rejected, (state, action) => {
      state.catloading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })
    .addCase(documentsActions.getDocumentsByCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      documentsActions.getDocumentsByCategory.fulfilled,
      (state, action) => {
        state.loading = false;
        state.documents_List = action.payload;
      }
    )
    .addCase(
      documentsActions.getDocumentsByCategory.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )
    //  updateDocRes
    .addCase(documentsActions.CreateDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(documentsActions.CreateDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.createDocRes = action.payload;
    })
    .addCase(documentsActions.CreateDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    .addCase(documentsActions.UpdateDocument.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(documentsActions.UpdateDocument.fulfilled, (state, action) => {
      state.loading = false;
      state.updateDocRes = action.payload;
    })
    .addCase(documentsActions.UpdateDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })
    //getAllDocuments
    .addCase(documentsActions.getAllDocuments.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(documentsActions.getAllDocuments.fulfilled, (state, action) => {
      state.loading = false;
      state.AlldocList = action.payload.data;
    })
    .addCase(documentsActions.getAllDocuments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    // getAllDocumentSearch
    .addCase(documentsActions.getAllDocumentSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      documentsActions.getAllDocumentSearch.fulfilled,
      (state, action) => {
        state.loading = false;
        state.AlldocList = action.payload.data;
      }
    )
    .addCase(
      documentsActions.getAllDocumentSearch.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    // DeleteDocments
    .addCase(documentsActions.DeleteDocments.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(documentsActions.DeleteDocments.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteRes = action.payload;
    })
    .addCase(documentsActions.DeleteDocments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    // DeleteDocments
    .addCase(documentsActions.dcoumentStatusChange.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      documentsActions.dcoumentStatusChange.fulfilled,
      (state, action) => {
        state.loading = false;
        state.statusChangeRes = action.payload;
      }
    )
    .addCase(
      documentsActions.dcoumentStatusChange.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    );
}
